// src/customer/customer-policy/customer-policy-commission/ReconcileSummary.tsx

import React from "react";
import { Panel, Row, Column } from "../../../components";
import { FloatingLabel, Form } from "react-bootstrap";
import { IReconcileSummary } from "./models/CommissionTypes";
import { fomratWithCommasAndDecimals } from "../../../shared/util/currencyUtils";
import { rateOrEmpty } from "./commissionFormatters";

interface IReconcileSummaryProps {
  data: IReconcileSummary;
}

const ReconcileSummary: React.FC<IReconcileSummaryProps> = ({ data }) => {
  if (!data) return null;

  return (
    <Panel
      title="Reconcile Summary"
      className="commission-panel-header"
      panelHeaderItems={
        <span className="commission-card-date">Compared to CM</span>
      }
    >
      <Row>
        <Column lg={6} md={6}>
          <Row className="mb-3">
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualPremium" label="Actual Premium">
                <Form.Control
                  type="text"
                  name="actualPremium"
                  value={`$${fomratWithCommasAndDecimals(data.actualPremium)}`}
                  placeholder="Actual Premium"
                  disabled
                />
              </FloatingLabel>
            </Column>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualCommission" label="Actual Commission">
                <Form.Control
                  type="text"
                  name="actualCommission"
                  value={`$${fomratWithCommasAndDecimals(data.actualCommission)}`}
                  placeholder="Actual Commission"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
          <Row className="mb-3">
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualFees" label="Actual Fees">
                <Form.Control
                  type="text"
                  name="actualFees"
                  value={`$${fomratWithCommasAndDecimals(data.actualFees)}`}
                  placeholder="Actual Fees"
                  disabled
                />
              </FloatingLabel>
            </Column>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualExpense" label="Actual Expense">
                <Form.Control
                  type="text"
                  name="actualExpense"
                  value={`$${fomratWithCommasAndDecimals(data.actualExpense)}`}
                  placeholder="Actual Expense"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
          <Row className="mb-3">
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualCommissionRate1" label="Actual Commission Rate 1">
                <Form.Control
                  type="text"
                  name="actualCommissionRate1"
                  value={rateOrEmpty(data.actualCommissionRate1)}
                  placeholder="Actual Commission Rate 1"
                  disabled
                />
              </FloatingLabel>
            </Column>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualCommissionRate2" label="Actual Commission Rate 2">
                <Form.Control
                  type="text"
                  name="actualCommissionRate2"
                  value={rateOrEmpty(data.actualCommissionRate2)}
                  placeholder="Actual Commission Rate 2"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
          <Row>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="actualCompensationRate" label="Actual Compensation Rate">
                <Form.Control
                  type="text"
                  name="actualCompensationRate"
                  value={rateOrEmpty(data.actualCompensationRate)}
                  placeholder="Actual Compensation Rate"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
        </Column>
        <Column lg={6} md={6}>
          <Row className="mb-3">
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedPremium" label="Estimated Premium">
                <Form.Control
                  type="text"
                  name="estimatedPremium"
                  value={`$${fomratWithCommasAndDecimals(data.estimatedPremium)}`}
                  placeholder="Estimated Premium"
                  disabled
                />
              </FloatingLabel>
            </Column>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedCommission" label="Estimated Commission">
                <Form.Control
                  type="text"
                  name="estimatedCommission"
                  value={`$${fomratWithCommasAndDecimals(data.estimatedCommission)}`}
                  placeholder="Estimated Commission"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
          <Row className="mb-3">
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedFees" label="Estimated Fees">
                <Form.Control
                  type="text"
                  name="estimatedFees"
                  value={`$${fomratWithCommasAndDecimals(data.estimatedFees)}`}
                  placeholder="Estimated Fees"
                  disabled
                />
              </FloatingLabel>
            </Column>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedExpense" label="Estimated Expense">
                <Form.Control
                  type="text"
                  name="estimatedExpense"
                  value={`$${fomratWithCommasAndDecimals(data.estimatedExpense)}`}
                  placeholder="Estimated Expense"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
          <Row className="mb-3">
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedRate1" label="Estimated Rate 1">
                <Form.Control
                  type="text"
                  name="estimatedRate1"
                  value={rateOrEmpty(data.estimatedRate1)}
                  placeholder="Estimated Rate 1"
                  disabled
                />
              </FloatingLabel>
            </Column>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedRate2" label="Estimated Rate 2">
                <Form.Control
                  type="text"
                  name="estimatedRate2"
                  value={rateOrEmpty(data.estimatedRate2)}
                  placeholder="Estimated Rate 2"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
          <Row>
            <Column lg={6} md={6}>
              <FloatingLabel controlId="estimatedCompensationRate" label="Estimated Compensation Rate">
                <Form.Control
                  type="text"
                  name="estimatedCompensationRate"
                  value={rateOrEmpty(data.estimatedCompensationRate)}
                  placeholder="Estimated Compensation Rate"
                  disabled
                />
              </FloatingLabel>
            </Column>
          </Row>
        </Column>
      </Row>
    </Panel>
  );
};

export default ReconcileSummary;
